<div class="is-flex flex-column">
    <span class="title-l ttu text-center mb-16">
        {{ 'dev.Myaccountpedidos.printedMessageTitleTW' | translate }}
    </span>
    <ng-container *ngIf="eguiRequested; else eguiNotRequested">
        <span class="text-l mb-20">
            {{ 'dev.Myaccountpedidos.printedMessage2TW' | translate }} {{ (eguiRequestedDate$ | async)?.printedRequestDate }}</span
        >
        <span class="text-l mb-20">
            {{ 'dev.Myaccountpedidos.printedMessage3TW' | translate }}
        </span>
        <span class="text-l mb-20">
            {{ 'dev.Myaccountpedidos.printedMessage4TW' | translate }}
        </span>
        <button class="btn btn-primary" (click)="requestEgui()">{{ 'dev.Myaccountpedidos.printedMessageButton' | translate }}</button>
    </ng-container>

    <ng-template #eguiNotRequested>
        <span class="text-l mb-20">
            {{ 'dev.Myaccountpedidos.printedMessage1TW' | translate }}
        </span>
    </ng-template>
</div>
